import { LinkButton } from "@digipost/dds-buttons-react";
import { useLanguage } from "@digipost/translate";
import { FC } from "react";

import BankId from "../../assets/images/auth/bankid.svg?react";
import Buypass from "../../assets/images/auth/buypass.svg?react";
import Translated from "../infrastructure/Translated";
import { useTranslate } from "../infrastructure/useTranslate";
import AuthTypeButton from "./AuthTypeButton";
import styles from "./AuthView.module.css";
import { LoginType } from "./loginType";

type Props = {
  onAuthRequestClick: (type: LoginType) => void;
  showHelpLinks: boolean;
};

const AuthView: FC<Props> = ({ onAuthRequestClick, showHelpLinks }) => {
  const translate = useTranslate();
  const { language } = useLanguage();
  const helpUrl =
    language === "en"
      ? "/en/consumer/help-and-contact"
      : `${language === "nb" ? "" : `/nn`}/privat/hjelp-og-kontakt`;

  return (
    <>
      <p>
        <Translated textKey="auth.register_org_info" />
      </p>

      <ul className={styles.loginCardList}>
        <li>
          <AuthTypeButton
            onAuthRequestClick={() => onAuthRequestClick("BANKID2")}
            logo={<BankId />}
            title={translate("auth.bankid")}
            description={translate("auth.bankid_info")}
          />
        </li>
        <li>
          <AuthTypeButton
            logo={<Buypass />}
            title={translate("auth.buypass")}
            description={translate("auth.buypass_info")}
            onAuthRequestClick={() => onAuthRequestClick("BUYPASS")}
          />
        </li>
      </ul>

      {showHelpLinks && (
        <ul className={styles.helpLinks}>
          <li>
            <LinkButton
              as="a"
              target="_blank"
              rel="noopener noreferrer"
              href={helpUrl}
            >
              <Translated textKey="auth.help" />
            </LinkButton>
          </li>
          <li>
            <LinkButton
              as="a"
              target="_blank"
              rel="noopener noreferrer"
              href="https://bankid.no/om-oss"
            >
              <Translated textKey="auth.about_bankid" />
            </LinkButton>
          </li>
          <li>
            <LinkButton
              as="a"
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.buypass.no/produkter/buypass-id-smartkort"
            >
              <Translated textKey="auth.about_buypass" />
            </LinkButton>
          </li>
          <li>
            <LinkButton
              as="a"
              target="_blank"
              rel="noopener noreferrer"
              href={helpUrl}
            >
              <Translated textKey="auth.help_bankid" />
            </LinkButton>
          </li>
        </ul>
      )}
    </>
  );
};

export default AuthView;
